/** Desktop companion constants (Wave 3). */

export const WEB_APP_ORIGIN =
  import.meta.env.VITE_WEB_APP_ORIGIN?.replace(/\/+$/, '') ?? 'https://app.trovepile.com';

const CHROME_STORE_BASE = import.meta.env.VITE_CHROME_EXTENSION_STORE_URL as string | undefined;

/** Chrome Web Store or in-app downloads fallback with UTM tracking. */
export function chromeExtensionInstallUrl(source = 'desktop_app'): string {
  if (CHROME_STORE_BASE) {
    const u = new URL(CHROME_STORE_BASE);
    u.searchParams.set('utm_source', source);
    return u.toString();
  }
  return `${WEB_APP_ORIGIN}/#/settings/downloads?utm_source=${encodeURIComponent(source)}`;
}

/** Opens in Chrome; extension embedded app runs restore via ?action=restore. */
export function sessionRestoreHandoffUrl(sessionId: string): string {
  const u = new URL(`${WEB_APP_ORIGIN}/tabs/${encodeURIComponent(sessionId)}/list`);
  u.searchParams.set('action', 'restore');
  return u.toString();
}

export const DESKTOP_LATEST_VERSION_JSON =
  import.meta.env.VITE_DESKTOP_LATEST_VERSION_URL ??
  'https://trovepile.com/desktop-latest.json';

export const DESKTOP_DOWNLOAD_PAGE =
  import.meta.env.VITE_DESKTOP_DOWNLOAD_PAGE ?? 'https://trovepile.com/download.html';
